





























import { Component, Vue } from 'vue-property-decorator';

// 声明组件*****************
@Component({
  components: {

  }
})
export default class ChooseAssociated extends Vue {
    // 属性*****************
    private inputValue: string = '0';
    private associatHidden: string = '';

    // 方法*****************
    private changeInputValue(value): void {
        this.inputValue = value;
    }
    private submit(): void {
        this.associatHidden = 'associatHidden';
        const id = setTimeout(()=>{
            this.$parent['associatShow'] = false;
            clearTimeout(id)
        },300)
    }
}
